import { BuildClass, Do, fsmData, leftpad, timer, } from '../../universal';
import { React, _ } from '../lib';
import { J2rButton } from './component-buttons';
import { J2rComboBox } from './component-combobox';
import { Alerts } from './component-main';
import { J2rText, j2r, j2rLabel, reactFlyout, reactFlyoutNew } from './component-react';
import { J2rTextAutoComplete } from './component-react-autocomplete';
import { svrtsRequest } from './svrts-interface';
import { Bindings, stubDiv, stubInput } from './ui5';
export class AddressWidget extends React.Component {
    hiddenInput;
    constructor(props) {
        super(props);
        Bindings(this, [this.openModalForm, this.evKeyPress]);
        this.hiddenInput = React.createRef();
        this.state = { isFocused: false };
    }
    render() {
        return j2r({
            cl: BuildClass({
                address_preview_widget: true,
                react: true,
                [this.props.cl ?? '']: true,
                filled: this.props.value != null,
                noclick: this.props.noClick ?? false,
                focused: this.state.isFocused,
            }),
            children: [
                this.buildHiddenInput(),
                {
                    tag: 'span',
                    cl: 'icon',
                    key: 'icon',
                    children: [
                        {
                            tag: 'img',
                            key: 'img',
                            src: '/static/img/svg/map-marker.svg',
                        },
                    ],
                },
                {
                    tag: 'span',
                    cl: 'lbl',
                    key: 'lbl',
                    text: Do(() => {
                        const A = this.props.value;
                        if (this.props.textOverride != null) {
                            return this.props.textOverride;
                        }
                        else if (A == null) {
                            return '';
                        }
                        else if (A.Complete) {
                            return `${A.Address}, ${A.Locale} ${A.State} ${A.PostCode}`;
                        }
                        return A.Note ?? '';
                    }),
                },
            ],
            onClick: this.openModalForm,
        });
    }
    buildHiddenInput() {
        return {
            tag: 'span',
            cl: 'focus-control-wrapper',
            key: 'focus-wrapper',
            children: [
                {
                    tag: 'input',
                    key: 'focus-control',
                    cl: 'focus-control',
                    onFocus: () => {
                        this.setState({ isFocused: true });
                    },
                    onBlur: () => {
                        this.setState({ isFocused: false });
                    },
                    onKeyPress: this.evKeyPress,
                    onClick: (e) => {
                        e.stopPropagation();
                    },
                    ref: this.hiddenInput,
                },
            ],
        };
    }
    evKeyPress(e) {
        const stopProp = () => {
            e.stopPropagation();
            e.preventDefault();
        };
        switch (e.which) {
            case 13:
            case 32:
                stopProp();
                this.openModalForm();
                break;
        }
    }
    openModalForm() {
        if (this.props.noClick) {
            return;
        }
        let title = Do(() => {
            if (this.props.value != null) {
                return 'Edit Address Card';
            }
            return 'New Address Card';
        });
        if (this.props.title) {
            title += `: ${this.props.title}`;
        }
        reactFlyoutNew(title, [720, 400], {
            tag: AddressEditForm,
            address: this.props.value,
            getPostCodes: this.props.getPostCodes,
            isPostal: this.props.isPostal,
            sourceElement: this.hiddenInput.current,
            onUpdate: (v, dmodelAddresses) => {
                const addr = dmodelAddresses?.[v] ?? null;
                (this.props.onUpdate ?? _.noop)(addr, dmodelAddresses);
            },
        });
    }
}
class AddressEditForm extends React.Component {
    static states = ['ACT', 'VIC', 'NSW', 'QLD', 'TAS', 'SA', 'WA', 'NT'];
    constructor(props) {
        super(props);
        Bindings(this, [this.save, this.cancel, this.preview]);
        const value = this.props.address ?? {};
        this.state = {
            address: value.Address ?? '',
            locale: value.Locale ?? '',
            state: value.State ?? '',
            postCode: Do(() => {
                const pc = value.PostCode ?? '';
                if (pc) {
                    return leftpad(String(pc), 4, '0');
                }
                return '';
            }),
            note: value.Note ?? '',
            previewURL: '',
            showWidget: false,
            isLoading: false,
        };
    }
    componentWillUnmount() {
        timer(() => {
            this.props.sourceElement?.focus();
        });
    }
    render() {
        return j2r({
            cl: 'frmEditAddress',
            children: [
                {
                    cl: 'lhs col',
                    key: 'lhs',
                    children: [
                        j2rLabel('Address', '', () => ({
                            tag: J2rText,
                            cl: this.props.isPostal ? 'multi-line' : undefined,
                            multiLine: this.props.isPostal,
                            autoFocus: true,
                            value: this.state.address,
                            onUpdate: (v) => {
                                this.setState({ address: v });
                            },
                            autoComplete: 'off',
                        })),
                        j2rLabel('Locale', '', () => ({
                            tag: J2rTextAutoComplete,
                            value: this.state.locale,
                            placeholder: 'Start typing to auto-complete...',
                            searchExtra: true,
                            getOptions: async (resolve) => {
                                const fn = this.props.getPostCodes ?? Promise.resolve;
                                return new Promise(fn).then(postCodes => {
                                    resolve(fsmData(postCodes, {
                                        filter: pc => pc.IsValid,
                                        map: pc => ({
                                            key: pc.ID,
                                            text: pc.Locality,
                                            extra: Do(() => {
                                                const postcode = leftpad(String(pc.PostCode), 4, '0');
                                                return `${pc.State} ${postcode}`;
                                            }),
                                        }),
                                    }));
                                });
                            },
                            onUpdate: async (txt, objKey) => {
                                if (objKey == null) {
                                    this.setState({ locale: txt });
                                    return;
                                }
                                const fn = this.props.getPostCodes ?? Promise.resolve;
                                const postCodes = await new Promise(fn);
                                const locale = postCodes[String(objKey)];
                                if (locale) {
                                    this.setState({
                                        locale: locale.Locality,
                                        state: locale.State,
                                        postCode: leftpad(String(locale.PostCode), 4),
                                    });
                                }
                            },
                        })),
                        {
                            cl: 'j2r-label state-postcode',
                            key: 'state-postcode',
                            children: [
                                {
                                    tag: 'span',
                                    cl: 'lbl',
                                    key: 'lbl-state',
                                    text: 'State',
                                },
                                {
                                    tag: J2rComboBox,
                                    key: 'state',
                                    options: fsmData(AddressEditForm.states, {
                                        sort: x => x,
                                        map: x => ({ value: x, text: x }),
                                    }),
                                    maxLength: 3,
                                    value: this.state.state,
                                    onUpdate: (v) => {
                                        this.setState({ state: v.value ?? '' });
                                    },
                                },
                                {
                                    tag: 'span',
                                    key: 'lbl-postcode',
                                    cl: 'lbl lbl-postcode',
                                    text: 'Post Code',
                                },
                                {
                                    tag: J2rText,
                                    key: 'postcode',
                                    autoComplete: 'off',
                                    maxLength: 4,
                                    value: this.state.postCode,
                                    onUpdate: (v) => {
                                        this.setState({ postCode: v });
                                    },
                                },
                            ],
                        },
                        j2rLabel('Note', '', () => ({
                            tag: J2rText,
                            autoComplete: 'off',
                            value: this.state.note,
                            onUpdate: (v) => {
                                this.setState({ note: v });
                            },
                        })),
                        {
                            key: 'map-preview-wrapper',
                            cl: 'cntr map-preview',
                            children: [
                                {
                                    tag: J2rButton,
                                    key: 'map-preview',
                                    type: 'standard',
                                    label: 'Map Preview →',
                                    onClick: this.preview,
                                },
                            ],
                        },
                    ],
                },
                {
                    cl: 'rhs col',
                    key: 'rhs',
                    children: [
                        Do(() => {
                            if (this.state.previewURLStatic && !this.state.showWidget) {
                                return {
                                    tag: 'img',
                                    key: 'img',
                                    src: this.state.previewURLStatic,
                                    title: 'Click to convert to an interactive Google Map',
                                    onClick: () => {
                                        this.setState({ showWidget: true });
                                    },
                                };
                            }
                            else if (this.state.showWidget &&
                                this.state.previewURLWidget) {
                                return {
                                    tag: 'iframe',
                                    key: 'iframe',
                                    src: this.state.previewURLWidget,
                                };
                            }
                            return undefined;
                        }),
                    ],
                },
                {
                    cl: 'buttons cntr',
                    key: 'buttons',
                    children: [
                        {
                            tag: J2rButton,
                            type: 'submit',
                            key: 'save',
                            label: 'Save',
                            disabled: this.state.isLoading,
                            onClick: this.save,
                        },
                        {
                            tag: J2rButton,
                            type: 'standard',
                            key: 'cancel',
                            label: 'Cancel',
                            disabled: this.state.isLoading,
                            onClick: this.cancel,
                        },
                    ],
                },
            ],
        });
    }
    preview() {
        const text = Do(() => {
            const [a, b, c, d] = [
                this.state.address.trim(),
                this.state.locale.trim(),
                this.state.state.trim(),
                String(this.state.postCode).trim(),
            ];
            if (!(a && b && c && d)) {
                return null;
            }
            return `${a}, ${b} ${c} ${d}`;
        });
        if (text == null) {
            return;
        }
        const key = 'AIzaSyBip-ZTD43PTW0B04uDRv_hum_u-m5muc8';
        this.setState({
            previewURLStatic: Do(() => {
                const baseUrl = 'https://maps.googleapis.com/maps/api/staticmap';
                const addr_text = encodeURIComponent(text);
                let args = `?markers=${addr_text}&key=${key}`;
                args += '&zoom=16&size=350x290&maptype=roadmap';
                return baseUrl + args;
            }),
        });
        this.setState({
            previewURLWidget: Do(() => {
                const baseUrl = 'https://www.google.com/maps/embed/v1/place';
                return `${baseUrl}?q=${encodeURIComponent(text)}&key=${key}`;
            }),
        });
        this.setState({ showWidget: false });
    }
    cancel() {
        ;
        (this.props.flyout.Close ?? _.noop)();
    }
    save() {
        const vals = [
            this.state.address,
            this.state.locale,
            this.state.state,
            this.state.postCode,
            this.state.note,
        ];
        if (vals.filter(x => x).length === 0) {
            ;
            (this.props.onUpdate ?? _.noop)(null);
            (this.props.flyout.Close ?? _.noop)();
            return;
        }
        this.setState({ isLoading: true });
        svrtsRequest({
            data: {
                funcID: [2, 7],
                facilityTriOnline: window.rootData.Session.Facility,
                subFacilityTriOnline: window.rootData.Session.SubFacility ?? 0,
                address: {
                    Address: this.state.address.trim(),
                    Locale: this.state.locale.trim(),
                    State: this.state.state.trim(),
                    PostCode: String(this.state.postCode).trim(),
                    Note: this.state.note.trim(),
                },
            },
            no: data => {
                Alerts.Alert({ msg: data.message });
            },
            yes: data => {
                const addresses = data.hydrationData?.newData?.addresses;
                if (!addresses) {
                    throw new Error('Address hydration was not returned');
                }
                this.props.onUpdate?.(data.new_key, addresses);
                this.props.flyout.Close?.();
            },
            any: () => {
                this.setState({ isLoading: false });
            },
        });
    }
}
export const ContactWidgetHook = React.forwardRef((props, ref) => {
    const [isFocused, setIsFocused] = React.useState(false);
    const element = React.useRef(stubDiv);
    const hiddenInput = React.useRef(stubInput);
    const evKeyPress = (e) => {
        const stopProp = () => {
            e.stopPropagation();
            e.preventDefault();
        };
        switch (e.which) {
            case 13:
            case 32:
                stopProp();
                openModalForm();
                break;
        }
    };
    const openModalForm = () => {
        if (props.readOnly ?? false) {
            return;
        }
        if (!props.noClick) {
            reactFlyout('Edit Contact Card', [320, 370], React.createElement(ContactEditForm, { contact: props.value, sourceElement: hiddenInput.current, onUpdate: (v, dmodelContacts) => {
                    const card = dmodelContacts[v];
                    if (card) {
                        props.onUpdate?.(card, dmodelContacts);
                        props.onUpdateBackup?.(card, dmodelContacts);
                    }
                } }));
        }
    };
    React.useImperativeHandle(ref, () => ({
        getElement: () => hiddenInput.current,
        focus: () => {
            hiddenInput.current.focus();
        },
        select: () => {
            hiddenInput.current.focus();
        },
    }));
    const buildSpan = (icon, value) => (React.createElement("span", { className: BuildClass({
            icon: true,
            [icon]: true,
            exists: Boolean(value),
        }), title: value ? `${icon}: ${value}` : `No ${icon}` },
        React.createElement("img", { src: `/static/img/svg/${icon}.svg` })));
    return (React.createElement("div", { className: BuildClass({
            contact_preview_widget: true,
            react: true,
            [props.cl ?? '']: true,
            noclick: props.noClick ?? false,
            focused: isFocused,
        }), title: props.title, ref: element, onClick: openModalForm },
        React.createElement("span", { className: "focus-control-wrapper" },
            React.createElement("input", { className: "focus-control", onFocus: () => {
                    props.onFocus?.();
                    setIsFocused(true);
                }, onBlur: () => {
                    props.onBlur?.();
                    setIsFocused(false);
                }, onKeyPress: evKeyPress, onClick: (e) => {
                    e.stopPropagation();
                }, ref: hiddenInput })),
        buildSpan('email', props.value?.Email),
        buildSpan('phone', props.value?.Phone),
        buildSpan('mobile', props.value?.Mobile),
        buildSpan('fax', props.value?.Fax),
        buildSpan('website', props.value?.Website)));
});
export class ContactWidget extends React.Component {
    element;
    hiddenInput;
    constructor(props) {
        super(props);
        Bindings(this, [this.openModalForm, this.evKeyPress]);
        this.element = React.createRef();
        this.hiddenInput = React.createRef();
        this.state = { isFocused: false };
    }
    render() {
        return j2r({
            ref: this.element,
            cl: BuildClass({
                contact_preview_widget: true,
                react: true,
                [this.props.cl ?? '']: true,
                noclick: this.props.noClick ?? false,
                focused: this.state.isFocused,
            }),
            children: [
                this.buildHiddenInput(),
                this.span('email', this.props.value?.Email),
                this.span('phone', this.props.value?.Phone),
                this.span('mobile', this.props.value?.Mobile),
                this.span('fax', this.props.value?.Fax),
                this.span('website', this.props.value?.Website),
            ],
            onClick: this.openModalForm,
        });
    }
    buildHiddenInput() {
        return {
            tag: 'span',
            cl: 'focus-control-wrapper',
            key: 'focus-wrapper',
            children: [
                {
                    tag: 'input',
                    key: 'focus-control',
                    cl: 'focus-control',
                    onFocus: () => {
                        this.setState({ isFocused: true });
                    },
                    onBlur: () => {
                        this.setState({ isFocused: false });
                    },
                    onKeyPress: this.evKeyPress,
                    onClick: (e) => {
                        e.stopPropagation();
                    },
                    ref: this.hiddenInput,
                },
            ],
        };
    }
    span(icon, value) {
        return {
            tag: 'span',
            key: icon,
            cl: BuildClass({
                icon: true,
                [icon]: true,
                exists: Boolean(value),
            }),
            children: [
                {
                    tag: 'img',
                    key: 'icon',
                    src: `/static/img/svg/${icon}.svg`,
                },
            ],
            title: Do(() => {
                if (value) {
                    return `${icon}: ${value}`;
                }
                return `No ${icon}`;
            }),
        };
    }
    evKeyPress(e) {
        const stopProp = () => {
            e.stopPropagation();
            e.preventDefault();
        };
        switch (e.which) {
            case 13:
            case 32:
                stopProp();
                this.openModalForm();
                break;
        }
    }
    openModalForm() {
        if (!this.props.noClick) {
            reactFlyoutNew('Edit Contact Card', [320, 370], {
                tag: ContactEditForm,
                contact: this.props.value,
                sourceElement: this.hiddenInput.current,
                onUpdate: (v, dmodelContacts) => {
                    const card = dmodelContacts[v];
                    (this.props.onUpdate ?? _.noop)(card, dmodelContacts);
                    (this.props.onUpdateBackup ?? _.noop)(card, dmodelContacts);
                },
            });
        }
    }
}
class ContactEditForm extends React.Component {
    constructor(props) {
        super(props);
        Bindings(this, [this.save, this.cancel, this.validateForm]);
        this.state = {
            email: this.props.contact?.Email ?? '',
            phone: this.props.contact?.Phone ?? '',
            mobile: this.props.contact?.Mobile ?? '',
            fax: this.props.contact?.Fax ?? '',
            website: this.props.contact?.Website ?? '',
            errors: {
                email: false,
                phone: false,
                mobile: false,
                fax: false,
                website: false,
            },
        };
        this.state = _.assign({}, this.state, this.validateForm(false));
    }
    componentWillUnmount() {
        timer(() => {
            this.props.sourceElement?.focus();
        });
    }
    render() {
        return j2r({
            cl: 'frmEditContact',
            children: [
                j2rLabel('Email', '', () => ({
                    tag: J2rText,
                    cl: this.state.errors.email ? 'error' : undefined,
                    autoFocus: true,
                    autoComplete: 'off',
                    value: this.state.email,
                    onBlur: () => this.validateForm(true),
                    onUpdate: (v) => {
                        this.setState({ email: v }, () => this.validateForm());
                    },
                })),
                j2rLabel('Phone', '', () => ({
                    tag: J2rText,
                    cl: this.state.errors.phone ? 'error' : undefined,
                    autoComplete: 'off',
                    value: this.state.phone,
                    onBlur: () => this.validateForm(true),
                    onUpdate: (v) => {
                        this.setState({ phone: v }, () => this.validateForm());
                    },
                })),
                j2rLabel('Mobile', '', () => ({
                    tag: J2rText,
                    cl: this.state.errors.mobile ? 'error' : undefined,
                    autoComplete: 'off',
                    value: this.state.mobile,
                    onBlur: () => this.validateForm(true),
                    onUpdate: (v) => {
                        this.setState({ mobile: v }, () => this.validateForm());
                    },
                })),
                j2rLabel('Fax', '', () => ({
                    tag: J2rText,
                    cl: this.state.errors.fax ? 'error' : undefined,
                    autoComplete: 'off',
                    value: this.state.fax,
                    onBlur: () => this.validateForm(true),
                    onUpdate: (v) => {
                        this.setState({ fax: v }, () => this.validateForm());
                    },
                })),
                j2rLabel('Website', '', () => ({
                    tag: J2rText,
                    cl: this.state.errors.website ? 'error' : undefined,
                    autoComplete: 'off',
                    value: this.state.website,
                    onBlur: () => this.validateForm(true),
                    onUpdate: (v) => {
                        this.setState({ website: v }, () => this.validateForm());
                    },
                })),
                {
                    cl: 'buttons cntr',
                    key: 'buttons',
                    children: [
                        {
                            tag: J2rButton,
                            type: 'submit',
                            disabled: _.size(_.compact(_.values(this.state.errors))) > 0,
                            key: 'save',
                            label: 'Save',
                            onClick: this.save,
                        },
                        {
                            tag: J2rButton,
                            type: 'standard',
                            key: 'cancel',
                            label: 'Cancel',
                            onClick: this.cancel,
                        },
                    ],
                },
            ],
        });
    }
    validateForm(validate = false) {
        const email = this.isValidEmail(this.state.email);
        let phone = this.isValidPhone(this.state.phone);
        let mobile = this.isValidMobile(this.state.mobile);
        const fax = this.isValidPhone(this.state.fax);
        const website = this.isValidWebsite(this.state.website);
        if (!phone && !this.state.mobile && this.isValidMobile(this.state.phone)) {
            mobile = this.isValidMobile(this.state.phone);
            phone = '';
        }
        if (!mobile && !this.state.phone && this.isValidPhone(this.state.mobile)) {
            mobile = '';
            phone = this.isValidPhone(this.state.mobile);
        }
        const stateDelta = {
            email: email === false ? this.state.email : email,
            phone: phone === false ? this.state.phone : phone,
            mobile: mobile === false ? this.state.mobile : mobile,
            fax: fax === false ? this.state.fax : fax,
            website: website === false ? this.state.website : website,
            errors: {
                email: email === false,
                phone: phone === false,
                mobile: mobile === false,
                fax: fax === false,
                website: website === false,
            },
        };
        if (validate && _.size(stateDelta) > 0) {
            this.setState(stateDelta);
        }
        return stateDelta;
    }
    isValidEmail(email) {
        email = (email ?? '').replace(/\s/g, '');
        if (!email) {
            return '';
        }
        const re = new RegExp(`\
(\
([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)\
|(".+")\
)\
@\
(\
(\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])\
|\
(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,})\
)\
$\
`);
        if (!re.test(email)) {
            return false;
        }
        return email;
    }
    isValidPhone(phone) {
        let b, c;
        phone = (phone ?? '').replace(/[^0-9]/g, '');
        if (!phone) {
            return '';
        }
        if (phone.substring(0, 2) === '61') {
            phone = `0${phone.substring(2)}`;
        }
        if (phone.length !== 10 && phone.length !== 8) {
            return false;
        }
        if (phone.length === 10 && phone.substring(0, 2) === '04') {
            return false;
        }
        if (phone.length === 10) {
            let a;
            [a, b, c] = [
                phone.substring(0, 2),
                phone.substring(2, 6),
                phone.substring(6, 10),
            ];
            return `${a} ${b} ${c}`;
        }
        ;
        [b, c] = [phone.substring(0, 4), phone.substring(4, 8)];
        return `${b} ${c}`;
    }
    isValidMobile(mobile) {
        mobile = (mobile ?? '').replace(/[^0-9]/g, '');
        if (!mobile) {
            return '';
        }
        if (mobile.substring(0, 2) === '61') {
            mobile = `0${mobile.substring(2)}`;
        }
        if (mobile.length !== 10) {
            return false;
        }
        if (mobile.substring(0, 2) !== '04' || mobile.length !== 10) {
            return false;
        }
        const [a, b, c] = [
            mobile.substring(0, 4),
            mobile.substring(4, 7),
            mobile.substring(7, 10),
        ];
        return `${a} ${b} ${c}`;
    }
    isValidWebsite(website) {
        website = (website ?? '').replace(/\s/g, '').toLowerCase();
        if (website.substring(0, 8) === 'https://') {
            website = website.substring(8);
        }
        if (website.substring(0, 7) === 'http://') {
            website = website.substring(7);
        }
        if (!website) {
            return '';
        }
        const re = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
        if (!re.test(website)) {
            return false;
        }
        return website;
    }
    cancel() {
        this.props.flyout?.Close();
    }
    save() {
        svrtsRequest({
            data: {
                funcID: [2, 8],
                facilityTriOnline: window.rootData.Session.Facility,
                subFacilityTriOnline: window.rootData.Session.SubFacility ?? 0,
                contact: {
                    Email: this.state.email,
                    Phone: this.state.phone,
                    Mobile: this.state.mobile,
                    Fax: this.state.fax,
                    Website: this.state.website,
                },
            },
            no: data => {
                Alerts.Alert({ msg: data.message });
            },
            yes: data => {
                const contacts = data.hydrationData?.newData?.contacts;
                if (!contacts) {
                    throw new Error('Contact hydration was not returned');
                }
                this.props.onUpdate?.(data.new_key, contacts);
                this.props.flyout?.Close();
            },
        });
    }
}
//# sourceMappingURL=component-address-contact.js.map